import MobileCountryCode from './attributes/MobileCountryCode';
import MobileNetworkCode from './attributes/MobileNetworkCode';
import TrackingAreaCode from './attributes/TrackingAreaCode';
import CellId from './attributes/CellId';
import BeaconsList from './attributes/BeaconsList';
import RSSI from './attributes/RSSI';
import WiFiMacAddresses from './attributes/WiFiMacAddresses';
export default {
  install(molten) {
    molten.addPlugin('Attribute', MobileCountryCode);
    molten.addPlugin('Attribute', MobileNetworkCode);
    molten.addPlugin('Attribute', TrackingAreaCode);
    molten.addPlugin('Attribute', CellId);
    molten.addPlugin('Attribute', BeaconsList);
    molten.addPlugin('Attribute', RSSI);
    molten.addPlugin('Attribute', WiFiMacAddresses);
  }
};